<div class="modal-header">
  <h4 md-dialog-title class="modal-title pull-left" [innerHTML]="title"></h4>
</div>

<div class="modal-body">
  <div *ngIf="list.length">
    <div *ngFor="let item of list">
      <div [innerHTML]="item"></div>
    </div>
  </div>
  <br /><br />
  <div *ngIf="showDetailedError()">
    <div>
      <mat-accordion>

        <mat-expansion-panel class="text-break" [expanded]="panelOpenState === true" (click)="setStep(0)">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Error Details
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p [innerHTML]="getErrorMessage()"></p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="close()" [innerHTML]="closeBtnName"></button>
  </div>